const KANBAN_PIPELINE_STAGES = new Set([
  'SALES_REVIEW', 'LEGAL_REVIEW', 'SIGNING', 'IMPLEMENTATION', 'BILLING', 'CLOSED'
]);

const STAGE_RANK = {
  ONBOARDING: 1,
  PROPUESTA: 1,
  SALES_REVIEW: 1,
  LEGAL: 2,
  LEGAL_REVIEW: 2,
  FIRMA: 3,
  SIGNING: 3,
  IMPLEMENTACION: 4,
  IMPLEMENTATION: 4,
  BILLING: 5,
  CIERRE: 5,
  CLOSED: 6,
  VERIFIED: 6
};

/** Etapa del tablero principal para un registro de renovación. */
export function renewalStageToPipelineStage(data = {}) {
  const s = data.stage;
  // La etapa del embudo de renovación prevalece sobre pipelineStage heredado del contrato operativo
  // (p. ej. CLOSED/VERIFIED en contratos no debe ocultar renovaciones en LEGAL).
  // Si Comercial ya confirmó a Legal pero `stage` no se actualizó, no regresamos a Rev. Com.
  if (s === 'PROPUESTA') {
    if (data.salesStatus === 'APPROVED' && data.pipelineStage === 'LEGAL_REVIEW') {
      return 'LEGAL_REVIEW';
    }
    return 'SALES_REVIEW';
  }
  if (s === 'LEGAL') return 'LEGAL_REVIEW';
  if (s === 'FIRMA') return 'SIGNING';
  if (s === 'IMPLEMENTACION' || s === 'IMPLEMENTATION') return 'IMPLEMENTATION';
  if (s === 'CIERRE') return data.facturado ? 'CLOSED' : 'BILLING';

  if (data.pipelineStage && KANBAN_PIPELINE_STAGES.has(data.pipelineStage)) {
    return data.pipelineStage;
  }
  return 'CLOSED';
}

export function pipelineStageToRenewalStage(pipelineStage) {
  const map = {
    SALES_REVIEW: 'PROPUESTA',
    ONBOARDING: 'PROPUESTA',
    LEGAL_REVIEW: 'LEGAL',
    SIGNING: 'FIRMA',
    IMPLEMENTATION: 'IMPLEMENTACION',
    BILLING: 'CIERRE',
    CLOSED: 'CIERRE'
  };
  return map[pipelineStage] || null;
}

function rank(value) {
  return STAGE_RANK[value] || 0;
}

/**
 * Unifica `stage` (embudo renovaciones) y `pipelineStage` (Kanban / Mesa Legal).
 * Si ambos vienen y chocan, gana la etapa más avanzada para no repetir el caso International.
 */
export function syncRenewalStageFields(data = {}) {
  const ps = data.pipelineStage;
  const st = data.stage;
  if (!ps && !st) return {};

  let nextPs = ps;
  let nextSt = st;

  if (ps && st && rank(ps) !== rank(st)) {
    if (rank(ps) >= rank(st)) {
      nextPs = ps;
      nextSt = pipelineStageToRenewalStage(ps) || st;
    } else {
      nextSt = st;
      nextPs = renewalStageToPipelineStage({ stage: st });
    }
  } else if (ps && !st) {
    nextSt = pipelineStageToRenewalStage(ps) || st;
  } else if (st && !ps) {
    nextPs = renewalStageToPipelineStage({ ...data, stage: st });
  }

  const out = {};
  if (nextSt) out.stage = nextSt;
  if (nextPs) out.pipelineStage = nextPs;
  return out;
}

/**
 * Merge del contrato original sobre una renovación: docs e identidad sí,
 * aprobación Legal / tipo Alta del ciclo anterior no.
 */
export function mergeRenewalDisplayFromOriginal(base = {}, renewal = {}) {
  return {
    ...base,
    ...renewal,
    id: renewal.id,
    isRenewal: true,
    pipelineStage: renewalStageToPipelineStage(renewal),
    stage: renewal.stage,
    salesStatus: renewal.salesStatus,
    legalStatus: renewal.legalStatus ?? null,
    legalSkipReason: renewal.legalSkipReason ?? null,
    movementType: renewal.movementType || 'Renovación'
  };
}

export { KANBAN_PIPELINE_STAGES };
